import { SvgIcon } from '@mui/material';
import React from 'react';

const ShippingInProgressIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="Calque_1"
        data-name="Calque 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 176.82 150.01"
        strokeWidth={0}
        fill="currentColor"
      >
        <path d="m146.7,52.23h-17.31v-21.98H49.64c-5.69,0-10.33,4.64-10.33,10.33v61.85h10.8v.24c0,9.45,7.66,17.11,17.11,17.11s17.13-7.65,17.13-17.11v-.24h33.7v.24c0,9.45,7.67,17.11,17.13,17.11s17.11-7.65,17.11-17.11v-.24h11.11v-28.24l-16.71-21.96Zm-79.47,59.09c-4.78,0-8.66-3.87-8.66-8.65,0-.07,0-.16.02-.24.11-4.69,3.93-8.44,8.64-8.44s8.55,3.75,8.66,8.44c.02.07.02.16.02.24,0,4.78-3.87,8.65-8.67,8.65Zm67.96,0c-4.8,0-8.67-3.87-8.67-8.65,0-.07,0-.16.02-.24.05-2.47,1.15-4.69,2.85-6.2,1.55-1.4,3.56-2.24,5.8-2.24,4.71,0,8.53,3.75,8.64,8.44.02.07.02.16.02.24,0,4.78-3.87,8.65-8.66,8.65Zm-5.8-37.13v-13.27h14.17l10.09,13.27h-24.26Z" />
        <polygon points="38.59 46.46 38.59 40.73 13.41 40.73 38.59 46.46" />
        <polygon points="38.59 54.5 38.59 48.78 13.41 48.78 38.59 54.5" />
        <polygon points="38.59 62.55 38.59 56.82 13.41 56.82 38.59 62.55" />
      </svg>
    </SvgIcon>
  );
};

export default ShippingInProgressIcon;
